























import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { Elevation, Document } from '~/models'
import DefaultImage from '~/mixins/defaultImage'

@Component({
  mixins: [DefaultImage],
})
export default class ElevationCardV3 extends mixins(DefaultImage) {
  @Prop({ default: (): Elevation => null })
  elevation: Elevation

  @Prop({ default: false }) selectElevation: boolean

  get imageSrc(): Document | string {
    return (
      (this.elevation?.photo?.source as string) ||
      this.elevation?.photo ||
      this.defaultImage()
    )
  }
}
